import React, { Component } from 'react'
import './ImgConvert.scss';
import { Input, Button, Image } from 'antd';
import { DownloadOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { geometryUtil } from './../../util/geometryUtil'
const { TextArea } = Input;
export default class ImgConvert extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dataUrl: "",
      geom: "",
    }
  }
  _onConvert = (e, type) => {

  }
  _onClear = (e, type) => {
  }
  _onChange = (e, type) => {
    this.setState({
      dataUrl: e.target.value
    })
  }
  _download = () => {
    const { dataUrl } = this.state;
    const url = dataUrl;
    // 下载时的文件名
    // const filename = 'downloaded.jpg';
    const a = document.createElement('a');
    a.href = url;
    // a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  render() {
    const { dataUrl } = this.state;
    return (
      <div className="img-convert">
        <div className="convert-area">
          <TextArea value={dataUrl} rows={22} placeholder="输入DataURI" onChange={(e) => this._onChange(e, "url")} />
          <div className="img-container">
            <Image
              width={200}
              src={dataUrl}
            />
            <DownloadOutlined onClick={this._download} />
          </div>
        </div>
        <div className="convert_btn">
          <Button onClick={this._onConvert}>转换</Button>
          <Button onClick={this._onClear}><ArrowLeftOutlined />清空</Button>
        </div>
      </div>
    )
  }
}